// react
import React from 'react';

// third-party
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

// application
import PageHeader from '../shared/PageHeader';

// data stubs
import theme from '../../data/theme';

const FAQ_SECTIONS = [
    {
        title: 'Akun & Belanja',
        items: [
            {
                q: 'Bagaimana cara membuat akun?',
                a: 'Pilih menu Akun, lalu Daftar. Isi data yang diminta dan akun siap dipakai untuk berbelanja.',
            },
            {
                q: 'Bagaimana cara berbelanja?',
                a: 'Cari produk lewat kolom pencarian atau menu Kategori, buka detail produk, lalu tekan tombol tambah ke keranjang.',
            },
            {
                q: 'Apakah harus login untuk checkout?',
                a: 'Ya. Anda perlu login agar alamat, pesanan, dan riwayat transaksi tersimpan di akun Anda.',
            },
            {
                q: 'Bagaimana jika lupa kata sandi?',
                a: 'Pilih Lupa Password di halaman login, lalu ikuti langkah pemulihan. Setelah masuk, kata sandi bisa diganti di menu Keamanan Akun.',
            },
        ],
    },
    {
        title: 'Pemesanan & Pembayaran',
        items: [
            {
                q: 'Bagaimana alur pemesanan produk?',
                a: 'Tambah produk ke keranjang, pilih produk yang ingin dibeli, lalu lanjut ke Checkout. Pilih alamat dan kurir, pilih metode pembayaran, dan selesaikan pembayaran.',
            },
            {
                q: 'Metode pembayaran apa yang tersedia?',
                a: 'Transfer Bank Langsung dan HokkyPay. Pilihan yang aktif akan tampil di halaman pembayaran.',
            },
            {
                q: 'Berapa lama batas waktu pembayaran?',
                a: 'Pesanan harus dibayar dalam 24 jam. Sisa waktunya tampil di halaman pembayaran dan detail pesanan.',
            },
            {
                q: 'Bagaimana konfirmasi setelah transfer?',
                a: 'Simpan bukti transfer, lalu kirim lewat tombol WhatsApp di halaman pesanan. Admin akan memvalidasi pembayaran Anda.',
            },
            {
                q: 'Di mana saya melihat status pesanan?',
                a: 'Buka menu Transaksi atau Akun, Pesanan Saya. Status seperti Menunggu Pembayaran, Lunas, Selesai, atau Dibatalkan tampil di tiap pesanan.',
            },
        ],
    },
    {
        title: 'Pengiriman & Alamat',
        items: [
            {
                q: 'Bagaimana cara menambah alamat?',
                a: 'Buka Akun, Daftar Alamat, lalu tambah alamat baru. Anda juga bisa menambahnya langsung saat checkout.',
            },
            {
                q: 'Bagaimana ongkos kirim dihitung?',
                a: 'Ongkos kirim dihitung otomatis saat checkout berdasarkan alamat tujuan, kurir yang dipilih, dan berat barang.',
            },
            {
                q: 'Mengapa titik lokasi alamat perlu diisi?',
                a: 'Titik lokasi membantu kurir menemukan alamat Anda dan membuat perhitungan ongkir lebih akurat.',
            },
        ],
    },
    {
        title: 'Layanan Jasa',
        items: [
            {
                q: 'Apa itu layanan jasa aplikator?',
                a: 'Layanan pemasangan atau pengerjaan oleh aplikator Hokky. Alurnya mulai dari pengajuan, jadwal survey, hasil RAB, pembayaran DP, pengerjaan, hingga pelunasan.',
            },
            {
                q: 'Bagaimana jika ada perubahan pekerjaan?',
                a: 'Ajukan revisi pesanan jasa. Biaya revisi dihitung lebih dulu dan dibayarkan setelah Anda menyetujuinya.',
            },
            {
                q: 'Bagaimana cara memantau komisi?',
                a: 'Buka halaman Komisi untuk melihat pengajuan dan riwayat komisi Anda.',
            },
        ],
    },
];

function SitePageFaq() {
    const breadcrumb = [
        { title: 'Home', url: '/' },
        { title: 'Pertanyaan Umum', url: '' },
    ];

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Pertanyaan Umum (FAQ) | ${theme.name}`}</title>
            </Helmet>

            <PageHeader breadcrumb={breadcrumb} />

            <div className="block faq">
                <div className="container">
                    {FAQ_SECTIONS.map((section) => (
                        <div key={section.title} className="faq__section">
                            <div className="faq__section-title">
                                <h3>{section.title}</h3>
                            </div>
                            <div className="faq__section-body">
                                <div className="row">
                                    {section.items.map((item) => (
                                        <div key={item.q} className="faq__section-column col-12 col-lg-6">
                                            <div className="typography">
                                                <h6>{item.q}</h6>
                                                <p>{item.a}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className="faq__section">
                        <div className="faq__section-body">
                            <div className="typography">
                                <p>
                                    Belum menemukan jawabannya? Hubungi kami di {theme.contacts.phone} atau{' '}
                                    {theme.contacts.email}, atau kunjungi{' '}
                                    <Link to="/site/contact-us">halaman kontak</Link>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default SitePageFaq;
